export const iconFontAwesomeAlphabetO = (
	<i className="fa-solid fa-o"></i>
);
